var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flex-layout',[_c('MFDetailModal',{attrs:{"menus":_vm.menus}}),_c('page-header',{attrs:{"heading":"Mutual Fund Detail Content","action":"Add","toggle":"offcanvas","target":"#offcanvasCreate","guard":this.$route.meta.guard},on:{"click":_vm.setCreateForm}}),_c('MFDetailTable',{attrs:{"tableHeading":_vm.tableHeading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }